import {
  getStringPositionFromConfig,
  renderPositions,
  renderStyles,
} from '../../shared/styles';

export const config = {
  context: 'iframe',
  defaultContext: 'iframe',
  allowedParentDomains: '*',
  autoResize: {
    width: false,
    height: false,
  },
  props: {
    height: {
      type: 'number',
    },
    width: {
      type: 'number',
    },
    widgetKey: {
      type: 'string',
      required: true,
    },
    position: {
      type: 'string',
      required: false,
      decorate: getStringPositionFromConfig,
      def: () => {
        return renderPositions.left;
      },
    },
    renderAs: {
      type: 'string',
      required: false,
      decorate: (renderAs) => {
        if (!renderStyles[renderAs]) {
          return renderStyles.fixed;
        }

        return renderAs;
      },
      def: () => {
        return renderStyles.fixed;
      },
    },
    ignoreURLPaths: {
      type: 'object',
      required: false,
    },
    bubble: {
      type: 'object',
      required: false,
      validate: ({ count }) => {
        if (typeof count !== 'number') {
          throw new TypeError('Expect bubble count to be a number');
        }

        if (count < 1 || count > 3) {
          throw new EvalError(
            'Expect bubble count to be between 1 and 3 inclusive'
          );
        }
      },
    },
    instanceId: {
      type: 'string',
      required: true,
    },
    listing: {
      type: 'object',
      required: false,
    },
    residents: {
      type: 'object',
      required: true,
    },
    screen: {
      type: 'object',
      required: true,
    },
    store: {
      type: 'object',
      required: true,
    },
    knockDoor: {
      type: 'object',
      required: true,
    },
    getIsKnockReady: {
      type: 'function',
      required: true,
    },
    analytics: {
      type: 'object',
      required: true,
    },
    eventDetail: {
      type: 'object',
      required: false,
    },
    zoid: {
      type: 'object',
      required: false,
    },
    onIntegration: {
      type: 'function',
      required: true,
    },
    onToggleMessenger: {
      type: 'function',
      required: true,
    },
    onTooltipDisplay: {
      type: 'function',
      required: true,
    },
    getIsOpen: {
      type: 'function',
      required: true,
    },
    onReadyDispatcher: {
      type: 'function',
      required: true,
    },
    getCurrentFeatureKey: {
      type: 'function',
      required: true,
    },
    onDispatchTriggerAttributes: {
      type: 'function',
      required: true,
    },
    addEventListener: {
      type: 'function',
      required: true,
    },
    removeEventListener: {
      type: 'function',
      required: true,
    },
    getEvent: {
      type: 'function',
      required: true,
    },
    betterBot: {
      type: 'object',
      required: true,
    },
    getParentURL: {
      type: 'function',
      required: true,
    },
    openCreateAccount: {
      type: 'function',
      required: true,
    },
    getExperiment: {
      type: 'function',
      required: true,
    },
  },
};
